import { render, staticRenderFns } from "./BusinessCardIframe.vue?vue&type=template&id=4fc08e4f&"
import script from "./BusinessCardIframe.vue?vue&type=script&lang=js&"
export * from "./BusinessCardIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports